<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">أنا صُنعت من الظلام أنا كُلياً سوداء</h1>
<ol class="toc">
<li id="toc-li-2"><a href="#/text/ch002#ايون"><span dir="rtl">ايون</span></a></li>
<li id="toc-li-3"><a href="#/text/ch003#الإهـداء"><span dir="rtl">الإهـداء</span></a></li>
<li id="toc-li-4"><a href="#/text/ch004#حقوق-النشر"><span dir="rtl">حقوق النشر</span>©</a></li>
<li id="toc-li-5"><a href="#/text/ch005#شكر-وتقدير"><span dir="rtl">شكر وتقدير</span></a></li>
<li id="toc-li-6"><a href="#/text/ch006#لماذا-أرتدي-الاسود"><span dir="rtl">لماذا أرتدي الاسود؟</span> : <span style="direction:ltr;">? Why I’m wearing black</span></a><ol class="toc"><li id="toc-li-7"><a href="#/text/ch006#why-im-wearing-black"></a></li>
</ol></li>
<li id="toc-li-8"><a href="#/text/ch007#تقبل-الاختلاف"><span dir="rtl">تقبل الاختلاف</span> : Accept the Difference</a><ol class="toc"><li id="toc-li-9"><a href="#/text/ch007#accept-the-difference"></a></li>
</ol></li>
<li id="toc-li-10"><a href="#/text/ch008#تقبل-الاختلاف-1"><span dir="rtl">تقبل الاختلاف</span> : Accept the Difference</a><ol class="toc"><li id="toc-li-11"><a href="#/text/ch008#accept-the-difference-1"></a></li>
</ol></li>
<li id="toc-li-12"><a href="#/text/ch009#نرجسية"><span dir="rtl">نرجسية</span> : Narcissistic</a><ol class="toc"><li id="toc-li-13"><a href="#/text/ch009#narcissistic"></a></li>
</ol></li>
<li id="toc-li-14"><a href="#/text/ch010#سعيد"><span dir="rtl">سَعيد</span> : Happy</a><ol class="toc"><li id="toc-li-15"><a href="#/text/ch010#happy"></a></li>
</ol></li>
<li id="toc-li-16"><span href="#/text/ch011#أنا-مؤمن" title="Link target outside of Sample"><span dir="rtl">أنا مؤمن</span> : I’m a believer</span><ol class="toc"><li id="toc-li-17"><span href="#/text/ch011#im-a-believer" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-18"><span href="#/text/ch012#روح-سوداء" title="Link target outside of Sample"><span dir="rtl">روحٌ سوداء</span> : Black Soul</span><ol class="toc"><li id="toc-li-19"><span href="#/text/ch012#black-soul" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-20"><span href="#/text/ch013#أنا-شيطان" title="Link target outside of Sample"><span dir="rtl">أنا شيطان</span> : I’m Satan</span><ol class="toc"><li id="toc-li-21"><span href="#/text/ch013#im-satan" title="Link target outside of Sample"></span></li>
</ol></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?40ef35ca